var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIkmLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 106,
    height: 20,
    viewBox: "0 0 106 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    id: "null",
    className: "svg logo_dark replaced-svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 7H26V20H16V7Z",
    fill: "#B0CB1F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 7H26.25V20H16V7ZM16.4881 7.48148V19.5185H25.7619V7.48148H16.4881Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.8894 0H5.81197L25.8894 17.7544L25.8894 0Z",
    fill: "#EA5A21"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.2212 0H5.64597L26.2212 18.2522V0ZM25.752 0.485598V17.1964L6.91434 0.485598H25.752Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M8.05298 10.4766H13.4955V16.3726H8.05298V10.4766Z",
    fill: "#EA5A21"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.59961 10.4766H13.9492V16.8261H7.59961V10.4766ZM8.08804 10.965V16.3377H13.4607V10.965H8.08804Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M55.1416 8.20703H59.2235V12.2889H55.1416V8.20703Z",
    fill: "#EA5A21"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M79.29 8.20703H83.3719V12.2889H79.29V8.20703Z",
    fill: "#EA5A21"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M47.6455 19.5467V9.96796L40.8335 19.5467H37V0.498047H41.9366V10.0768L48.7486 0.498047H52.5545V19.5467H47.6455Z",
    fill: "#5B5B5B"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M78.2251 19.5467H72.7093L67.166 11.0292V19.5467H62.2293V0.498047H67.166V8.49849L72.4335 0.498047H77.9493L71.8268 9.75026L78.2251 19.5467Z",
    fill: "#5B5B5B"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M105.938 0.498047V19.5467H101.029V9.28765L97.3406 14.9343H94.8442L91.1833 9.31486V19.5467H86.2467V0.498047H91.1833L96.0924 8.63455L101.029 0.498047H105.938Z",
    fill: "#5B5B5B"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M0.331787 0H15.2654L0.331787 17.2566L0.331787 0Z",
    fill: "#0E74B4"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 0H15.9292L0 17.7544V0ZM0.473595 0.482616V16.5113L14.8545 0.482616H0.473595Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIkmLogo);
export default __webpack_public_path__ + "static/media/ikm-logo.429a17ce670f4b843025a9a6c0f71f88.svg";
export { ForwardRef as ReactComponent };